import React, { useMemo } from "react";
import Button from "atoms/buttons/button";
import { ButtonStyles } from "atoms/constants/button-styles";
import { Icons } from "atoms/constants/icons";
import Icon from "atoms/icons/icon";
import DeprecatedShow from "atoms/wrappers/show";
import PublicationRecord from "models/view-models/publication-record";
import SectionRecord from "models/view-models/section-record";
import StringUtils from "utilities/string-utils";

interface CodeRefrencePillProps {
    cssClassName?: string;
    focused?: boolean;
    onReferenceClick?: (section: SectionRecord) => void;
    onReferencePillClose?: () => void;
    publication?: PublicationRecord;
    removeable?: boolean;
    section: SectionRecord;
}

const BASE_CLASS_NAME = "c-code-reference-pill";

export const CodeReferencePill: React.FC<CodeRefrencePillProps> = ({
    cssClassName,
    focused = false,
    onReferenceClick,
    onReferencePillClose,
    publication,
    removeable = false,
    section,
}) => {
    const handleReferenceClick = () => {
        onReferenceClick?.(section);
    };

    const handleReferenceCloseClick = () => {
        onReferencePillClose?.();
    };

    const wrapperClassName = useMemo(() => {
        const classNames = [BASE_CLASS_NAME];

        if (StringUtils.hasValue(cssClassName)) {
            classNames.push(cssClassName);
        }

        return classNames.join(" ");
    }, [cssClassName]);

    const buttonClassName = useMemo(() => {
        const classNames = [`${BASE_CLASS_NAME}__button`];

        if (focused) {
            classNames.push("-focus");
        }

        return classNames.join(" ");
    }, [focused]);

    return (
        <div className={wrapperClassName}>
            <Button
                cssClassName={buttonClassName}
                onClick={handleReferenceClick}
                style={ButtonStyles.None}>
                <span className={`${BASE_CLASS_NAME}__title`}>
                    {publication &&
                        `NFPA ${publication.code} (${publication.edition}) `}
                    {section?.getFullyQualifiedDisplayTitle()}
                </span>
            </Button>
            <DeprecatedShow when={removeable}>
                <Button
                    cssClassName={`${BASE_CLASS_NAME}__close`}
                    onClick={handleReferenceCloseClick}
                    style={ButtonStyles.Text}>
                    <Icon type={Icons.Close} />
                </Button>
            </DeprecatedShow>
        </div>
    );
};
